import React, { Component } from 'react';
import { connect } from 'react-redux';
import Favorite from '../../../../SHARED/components/favorite/favorite.component';
import Parser from 'html-react-parser';

class MovieTheaterDetails extends Component {

    constructor(props) {
        super(props);
    }

    showMap() {
        this.props.showMap();
    }

    goTo(url) {
        window.open(url, '_blank');
    }

    render() {
        return (
            <div className="movie-theater-details-container" key={this.props.id}>
                <div className="row">
                    <div className="col-md-10">
                        <div className="title">{this.props.name}</div>         
                    </div>
                    <div className="col-md-2">
                        { this.props.favorite !== "none" ?
                        <Favorite 
                            favorite={this.props.favorite}
                            component="list"
                            type="cinema"
                            id={this.props.uuid}
                        /> : ""
                        }
                    </div>
                </div>
                <div className="col address">
                    {!this.props.isSearchPage && <div>
                        <span>{this.props.address !== '' ? 'Adresă: ' + this.props.address : ''}</span>
                        <span className="map" onClick={() => this.showMap()}>Vezi harta</span>
                    </div>}
                    <div>
                        <span>{this.props.halls !== '' ? 'Număr săli: ' + this.props.halls : ''}</span>
                    </div>
                    <div>
                        <span>{this.props.phone !== '' ? 'Telefon: ' + this.props.phone : ''}</span>
                    </div>
                    <div>
                        <span>{this.props.email !== '' ? 'Email: ' + this.props.email : ''}</span>
                    </div>
                    <div>
                        <span className="site-url" onClick={() => this.goTo(this.props.site)}>{this.props.site !== '' ? this.props.site : ''}</span>
                    </div>
                    <div className="movie-theater-description">
                        <span>{this.props.description !== '' ? Parser(this.props.description) : ''}</span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(MovieTheaterDetails);



// WEBPACK FOOTER //
// ./src/FO/components/movietheaters/containers/movietheatersdetails.component.js